export default __webpack_public_path__ + "static/media/business_analytics_img.1446204e.png";